// Generated by ReScript, PLEASE EDIT WITH CARE


var title = {
  id: "302a28de-559e-40a0-807b-94b41a217bb3",
  defaultMessage: "Advanced search"
};

var orderPeriod = {
  id: "80322300-1bd3-4f2d-9279-e54cfec66fd4",
  defaultMessage: "Order period"
};

var registrationPeriod = {
  id: "4dd7f8d5-8c1a-453f-a95e-51b4a2a95095",
  defaultMessage: "Registration period"
};

var custInvoicePeriod = {
  id: "1031cea2-95d9-4733-b3c8-14f8b7e3a262",
  defaultMessage: "Client invoicing period"
};

var delivered = {
  id: "f2b28686-98b9-4c8b-b8a2-7de7217b31a3",
  defaultMessage: "Delivered"
};

var protID = {
  id: "5823fa90-9ac1-476d-bfd5-c569ce7f4cc7",
  defaultMessage: "Prot/Renter Code"
};

var actionID = {
  id: "d1d437b0-ad3d-4f01-a8b9-3f3f5429d79d",
  defaultMessage: "Action ID"
};

var deliveryPeriod = {
  id: "6e899365-c384-4fa4-b30c-54d972e16bc8",
  defaultMessage: "Delivery period"
};

var deliveryPeriodBoth = {
  id: "39db6898-2e56-4e59-ab11-7c6b4f32eb1f",
  defaultMessage: "Delivery / desired delivery period"
};

var desiredDeliveryPeriod = {
  id: "4f118a42-6fea-441b-a11e-b5aa2297c1a2",
  defaultMessage: "Desired delivery period"
};

var renaultInvoiceDate = {
  id: "2311b1ec-dbf7-4295-ba56-7be3d0956cda",
  defaultMessage: "Renault invoice date"
};

var dealerName = {
  id: "7a651273-5400-4e2a-8d7a-cccc338ec0e2",
  defaultMessage: "Dealer name"
};

var dealerGroup = {
  id: "89fac1ed-c586-4c69-913a-8aea02b32c18",
  defaultMessage: "National group"
};

var keyAccountManagerID = {
  id: "03488636-b69d-4c12-b3d9-2b79a1442b3c",
  defaultMessage: "Key account manager ID"
};

var sectorManagerID = {
  id: "244253ba-7169-40d1-bc88-63e6ba1d31c1",
  defaultMessage: "Sector manager ID"
};

var sirenClientFinalLLD = {
  id: "cb9334a6-f2d4-442e-89be-75658e9fea16",
  defaultMessage: "VAT reg. code LLD"
};

var sirenClientFinalLLDName = {
  id: "546bee42-1827-4592-81f2-eb1c2f762ebd",
  defaultMessage: "Final client LLD name"
};

var sirenClientFinal = {
  id: "0b33f493-3c77-48b3-ab12-a5483529106e",
  defaultMessage: "SIREN Client Final"
};

var sirenClientFinalName = {
  id: "3806dbf9-ea76-4129-bb14-73ff60059838",
  defaultMessage: "Final Client Company Name"
};

var loueurID = {
  id: "31911448-efbb-472c-9cff-7d302730a548",
  defaultMessage: "Rental code"
};

var loueurName = {
  id: "01407b64-5ec1-4eaa-935b-7c81b3bb7ab4",
  defaultMessage: "Rental label"
};

var contractID = {
  id: "97b5678d-269e-4ec1-b8dd-9e9ab43dd3ec",
  defaultMessage: "Contract ID"
};

var contractName = {
  id: "cfe2bfb9-61fb-4bb6-93ac-0e884685a315",
  defaultMessage: "Contract label"
};

var mainContractSIREN = {
  id: "7473e308-6336-4807-8668-28cae22468c0",
  defaultMessage: "Main company of contract"
};

var preinvoiceDate = {
  id: "5e29dbc7-5c67-4e43-a2ba-99eddeb1c342",
  defaultMessage: "Preinvoice date"
};

var preinvoiceNumber = {
  id: "5204ef61-47fd-4605-8fcd-0040b3b2f1e2",
  defaultMessage: "Preinvoice number"
};

var dateBAP = {
  id: "dbfbcdbe-e671-4d9f-8f2e-74796673acf6",
  defaultMessage: "Date of payment"
};

var dateFilterPage = {
  id: "cce6575c-ad2a-4680-b3fb-a897571d2654",
  defaultMessage: "Date"
};

var codeAPE = {
  id: "09bc9fe7-ff97-4994-b42c-a95489f913fc",
  defaultMessage: "Activity code (APE)"
};

var codeAPEhint = {
  id: "87a86e56-2e79-4cf2-ae4c-d74982ecc96c",
  defaultMessage: "Press ENTER after each code"
};

var customerFilterPage = {
  id: "e8c09042-0863-4503-9f2e-c06de8562454",
  defaultMessage: "Client"
};

var dealerFilterPage = {
  id: "9ae625dd-7ae4-4ffc-86e4-5789eab9a431",
  defaultMessage: "Dealer"
};

var carFilterPage = {
  id: "3ed06b7e-260a-4a7d-b810-88ffdbf7ca01",
  defaultMessage: "VN"
};

var voFilterPage = {
  id: "f79b4a7e-641a-4c69-adda-67ae9e6dde44",
  defaultMessage: "UC"
};

var registeredDateCheckbox = {
  id: "ab8a7ec6-a940-428d-90d4-50cfc301efcf",
  defaultMessage: "Registration"
};

var invoicedCheckbox = {
  id: "72776ab5-be6f-4143-afb3-4e40f383e551",
  defaultMessage: "Invoices"
};

var parcAutomatic = {
  id: "06de3478-52f2-4dd3-91a2-94db74815348",
  defaultMessage: "Automatic exit PARC"
};

export {
  title ,
  orderPeriod ,
  registrationPeriod ,
  custInvoicePeriod ,
  delivered ,
  protID ,
  actionID ,
  deliveryPeriod ,
  deliveryPeriodBoth ,
  desiredDeliveryPeriod ,
  renaultInvoiceDate ,
  dealerName ,
  dealerGroup ,
  keyAccountManagerID ,
  sectorManagerID ,
  sirenClientFinalLLD ,
  sirenClientFinalLLDName ,
  sirenClientFinal ,
  sirenClientFinalName ,
  loueurID ,
  loueurName ,
  contractID ,
  contractName ,
  mainContractSIREN ,
  preinvoiceDate ,
  preinvoiceNumber ,
  dateBAP ,
  dateFilterPage ,
  codeAPE ,
  codeAPEhint ,
  customerFilterPage ,
  dealerFilterPage ,
  carFilterPage ,
  voFilterPage ,
  registeredDateCheckbox ,
  invoicedCheckbox ,
  parcAutomatic ,
}
/* No side effect */
